var _path, _path2, _path3, _path4, _path5, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function Svg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 34,
    viewBox: "0 0 37 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8755 26.2646L10.1492 22.7539L6.11182 30.4892L11.0122 29.2311L12.8382 33.9999L16.8755 26.2646ZM19.7832 26.2646L26.5096 22.7539L30.5469 30.4892L25.6466 29.2311L23.8206 33.9999L19.7832 26.2646Z",
    fill: "#5C1526"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4459 14.45C31.4459 21.6273 25.6275 27.4457 18.4501 27.4457C11.2727 27.4457 5.45435 21.6273 5.45435 14.45C5.45435 7.27263 11.2727 1.45424 18.4501 1.45424C25.6275 1.45424 31.4459 7.27263 31.4459 14.45Z",
    fill: "url(#paint0_linear_306_351)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9 14.45C32.9 22.4305 26.4305 28.9 18.45 28.9C10.4695 28.9 4 22.4305 4 14.45C4 6.46949 10.4695 0 18.45 0C26.4305 0 32.9 6.46949 32.9 14.45ZM18.4501 27.4457C25.6275 27.4457 31.4459 21.6273 31.4459 14.45C31.4459 7.27263 25.6275 1.45424 18.4501 1.45424C11.2727 1.45424 5.45435 7.27263 5.45435 14.45C5.45435 21.6273 11.2727 27.4457 18.4501 27.4457Z",
    fill: "#666666"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4501 25.9915C24.8243 25.9915 29.9916 20.8242 29.9916 14.45C29.9916 8.07579 24.8243 2.90849 18.4501 2.90849C12.0759 2.90849 6.90861 8.07579 6.90861 14.45C6.90861 20.8242 12.0759 25.9915 18.4501 25.9915ZM18.4501 27.4457C25.6275 27.4457 31.4459 21.6273 31.4459 14.45C31.4459 7.27263 25.6275 1.45424 18.4501 1.45424C11.2727 1.45424 5.45435 7.27263 5.45435 14.45C5.45435 21.6273 11.2727 27.4457 18.4501 27.4457Z",
    fill: "#B2B2B2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9035 17.7684V19.1652H16.3604V18.6582C16.3604 18.0882 16.4531 17.5398 16.6387 17.0129C16.8276 16.486 17.0546 16.0321 17.3197 15.651C17.5848 15.2666 17.8482 14.9054 18.11 14.5674C18.3751 14.2261 18.6004 13.8881 18.786 13.5534C18.9749 13.2154 19.0693 12.9006 19.0693 12.609V11.4309C19.0693 11.0565 18.9202 10.8693 18.622 10.8693C18.4795 10.8693 18.3635 10.919 18.274 11.0184C18.1879 11.1145 18.1448 11.2553 18.1448 11.4409V13.0762H16.4449V11.4508C16.4449 10.8345 16.6404 10.3473 17.0314 9.98946C17.4257 9.63158 17.9924 9.45264 18.7313 9.45264C19.3841 9.45264 19.8978 9.61501 20.2722 9.93976C20.65 10.2612 20.8389 10.6936 20.8389 11.2371V12.3157C20.8389 12.7432 20.7544 13.1789 20.5854 13.623C20.4164 14.067 20.2093 14.4729 19.964 14.8408C19.7221 15.2053 19.4786 15.5598 19.2334 15.9045C18.9881 16.2458 18.781 16.5805 18.612 16.9085C18.443 17.2333 18.3585 17.5199 18.3585 17.7684H20.9035Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_306_351",
    x1: 18.45,
    y1: 0,
    x2: 18.45,
    y2: 28.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A8A8A"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.0ec036ffbdda06653f2533fcad50f78d.svg";
export { ForwardRef as ReactComponent };